export default {
    data() {
        return {

        }
    },
    created() { },
    mounted() { },
    methods: {
        login() {
            this.$router.push({
                name: "单位管理",
                params: {
                    
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/login/login-mixins.js